import { Log } from '@servicetitan/log-service';
import { injectable, inject } from '@servicetitan/react-ioc';

@injectable()
export class AppErrorStore {
    private errorLogged = false;

    constructor(@inject(Log) private log: Log) {}

    logAppError = () => {
        if (this.errorLogged) {
            return;
        }

        this.errorLogged = true;

        if ((window as any).PortalSettings === undefined) {
            this.log.error({
                category: 'CP2.App.General',
                error: 'Error while loading portal. PortalSettings is undefined.',
            });
        }
    };
}
